import { Link } from 'react-router-dom';
import { HiArrowUpRight } from 'react-icons/hi2';
import Reveal from '../../../shared/Reveal/Reveal';
import './EconomicCalendar.css';

const WIDGET_CONFIG = {
  colorTheme: 'light',
  isTransparent: true,
  width: '100%',
  height: 560,
  locale: 'en',
  importanceFilter: '-1,0,1',
};

const calendarSrcDoc = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html,
      body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: #ffffff;
      }

      .tradingview-widget-container,
      .tradingview-widget-container__widget {
        width: 100%;
        height: 100%;
      }
    </style>
  </head>
  <body>
    <div class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget"></div>
      <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-events.js" async>
        ${JSON.stringify(WIDGET_CONFIG)}
      </script>
    </div>
  </body>
</html>`;

const EconomicCalendar = () => {
  return (
    <section className="insights-calendar">
      <div className="insights-calendar__inner">
        <Reveal className="insights-calendar__header">
          <div className="insights-calendar__heading">
            <p className="insights-calendar__eyebrow">Economic Calendar</p>
            <h2 className="insights-calendar__title">
              Track the Events That Move Markets.
            </h2>
          </div>

          <p className="insights-calendar__lead">
            Our real-time economic calendar tracks high-impact global events,
            central bank decisions, and macroeconomic releases — giving you the
            context to make informed financial decisions.
          </p>
        </Reveal>

        <Reveal className="insights-calendar__panel" delay={80}>
          <div className="insights-calendar__widget-shell">
            <iframe
              className="insights-calendar__frame"
              title="TradingView Economic Calendar"
              srcDoc={calendarSrcDoc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="insights-calendar__actions">
            <Link
              to="/insights/economic-calendar"
              className="insights-calendar__cta"
            >
              View Full Calendar
              <HiArrowUpRight
                className="insights-calendar__cta-icon"
                aria-hidden="true"
              />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default EconomicCalendar;
